import { useEffect, useState } from "react";
import { Check, X, ShieldCheck } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";
import { useI18n } from "@/context/I18nContext";
import { Card, Btn, CategoryIcon, Loader } from "@/components/portal/ui";

export function CrossApprovals() {
  const { t, L } = useI18n();
  const [items, setItems] = useState(null);

  const load = async () => {
    const { data } = await api.get("/control/approvals");
    setItems(data);
  };
  useEffect(() => { load(); }, []);

  const act = async (p, action) => {
    try {
      await api.post(`/control/providers/${p.id}/${action}`);
      toast.success(t("common.saved"));
      load();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  if (!items) return <Loader />;
  return (
    <div className="kw-fade">
      <h1 className="font-heading text-3xl font-bold mb-6" style={{ color: "var(--text)" }}>{t("control.approvals")}</h1>
      {items.length === 0 ? (
        <Card className="p-12 flex flex-col items-center gap-3 text-center" data-testid="cross-approvals-empty">
          <ShieldCheck className="h-8 w-8" style={{ color: "var(--accent)" }} />
          <span style={{ color: "var(--text-muted)" }}>{t("approve.empty")}</span>
        </Card>
      ) : (
        <div className="space-y-3" data-testid="cross-approvals-list">
          {items.map((p) => (
            <Card key={p.id} className="p-4 flex flex-wrap items-center gap-4 kw-fade-up" data-testid={`cross-approval-${p.id}`}>
              <div className="h-14 w-14 shrink-0 overflow-hidden flex items-center justify-center" style={{ background: "var(--surface-alt)", borderRadius: "var(--radius)" }}>
                {p.cover_image ? <img src={p.cover_image} alt="" className="h-full w-full object-cover" /> : <CategoryIcon name={p.categories?.[0]?.icon} className="h-6 w-6" style={{ color: "var(--text-muted)" }} />}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-[10px] uppercase tracking-widest px-2 py-1 rounded-full" style={{ background: "var(--surface-alt)", color: "var(--accent)" }}>{p.portal_key}</span>
                  <span className="font-heading text-lg font-semibold truncate" style={{ color: "var(--text)" }}>{p.business_name}</span>
                </div>
                <div className="text-sm truncate mt-0.5" style={{ color: "var(--text-muted)" }}>{p.categories?.map((c) => L(c.name)).join(", ")} · {L(p.location_name)}</div>
              </div>
              <div className="flex gap-2">
                <Btn variant="accent" onClick={() => act(p, "approve")} data-testid={`cross-approve-${p.id}`}><Check className="h-4 w-4" /> {t("approve.approve")}</Btn>
                <Btn variant="danger" onClick={() => act(p, "reject")} data-testid={`cross-reject-${p.id}`}><X className="h-4 w-4" /> {t("approve.reject")}</Btn>
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
